<template>
  <div>
    <div
      v-for="(reminder, i) in reminders"
      :key="i"
      class="flex space-between w-100"
    >
      <div class="reminder-starting-on">
        <div>{{ reminder.type }} starting on:</div>
        <div class="start-picker-container">
          <date-picker-slim
            class="start-picker"
            v-model="reminder.start"
            :onChange="getOnReminderStartDateChange(reminder.type)"
          ></date-picker-slim>
        </div>
      </div>
      <span class="flex reminder-container">
        <select
          id="reminder-select"
          class="reminder-dropdown blue-text"
          dir="rtl"
          v-on:change="onReminderFrequencyChange($event, reminder.type)"
        >
          <option
            v-for="frequencyOption in frequencyOptions"
            :key="frequencyOption.value"
            :value="frequencyOption.value"
            :selected="frequencyOption.value === reminder.frequency"
          >
            {{ frequencyOption.text }}
          </option>
        </select>
        <div class="arrow-down"></div>
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SitesService from '@/services/SitesService';
import DataEntryButton from './data-entry-button';
import DatePickerSlim from '@/components/date-picker-slim';

export default {
  components: {
    DataEntryButton,
    DatePickerSlim,
  },

  props: {
    mappable: Object,
  },

  computed: {
    reminders() {
      const reminders = this.mappable.buildReminders();
      const reducer = (acc, type) => [
        ...acc,
        {
          type,
          frequency: reminders[type].frequency,
          start: reminders[type].start || moment().format('MM-DD-YY'),
        },
      ];
      return Object.keys(reminders).reduce(reducer, []);
    },
    frequencyOptions() {
      return [0, 5, 7, 14, 30].map((days) => ({
        value: days,
        text: days ? `Every ${days} days` : 'None',
      }));
    },
  },

  methods: {
    getOnReminderStartDateChange(type) {
      const { mappable } = this;
      const { id } = mappable;
      return (date) => {
        const scheduleStartDate = moment(date).format('YYYY-MM-DD');
        const scheduleStartProperty = `${type}ScheduleStart`;
        const update = {
          id,
          [scheduleStartProperty]: scheduleStartDate,
        };
        SitesService.update(update);
        mappable[scheduleStartProperty] = date;
        mappable.updateScheduled();
      };
    },
    onReminderFrequencyChange({ target }, type) {
      const { selectedIndex } = target.options;
      const selection = this.frequencyOptions[selectedIndex];
      const reminderInterval = selection.value;
      const updateProperty = `${type}ScheduleFrequency`;
      const update = {
        id: this.mappable.id,
        [updateProperty]: reminderInterval,
      };
      this.mappable[updateProperty] = reminderInterval;
      this.mappable.updateScheduled();
      SitesService.update(update);

      const startProperty = `${type}ScheduleStart`;
      if (this.mappable[startProperty] === null) {
        const updateStartDate = this.getOnReminderStartDateChange(type);
        updateStartDate();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';
.reminder-starting-on {
  display: flex;
  font-family: Roboto;
  font-size: 11.2px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);

  & div:first-letter {
    text-transform: capitalize;
  }

  & .start-picker-container {
    position: relative;
    bottom: 0.1rem;
    left: 0.1rem;
  }
}

.flex {
  position: relative;
  top: 2px;

  &.space-between:not(:last-of-type) {
    margin-bottom: 1rem;
  }
}

.reminder-container {
  width: 10rem;
  position: relative;
  right: 1rem;
}

.reminder-dropdown {
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  cursor: pointer;
  outline: none;
  padding-left: 4px;
  padding-right: 20px;
  position: relative;
  left: 24px;
}

.arrow-down {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid $black;
  margin-left: 6px;
  pointer-events: none;
  position: relative;
  right: -4px;
  top: 5px;
  width: 0;
  height: 0;
}

.blue-text {
  border: none;
  color: $blue;
  font-family: Roboto;
  font-size: 11.2px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  position: relative;
  bottom: 2px;
  text-transform: uppercase;
}
</style>
